/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    ApiError400DefaultCodeEnum,
    ApiError404DefaultCodeEnum,
    ApiError500DefaultCodeEnum,
    ErrorCode,
} from 'client-code/actions';

import { AppError } from './AppError';
import { ErrorTypes } from './ErrorTypes';

export class CollectionScreenError extends AppError {
    public constructor(code: string, message: string) {
        super(code, message);
        this.setCode(code);
    }

    private setCode(code: string): void {
        switch (code) {
            case ErrorCode.Apigw401:
            case ErrorCode.Apigw4Xx:
            case ErrorCode.Apigw5Xx:
            case ApiError400DefaultCodeEnum.ApigwError:
            case ApiError500DefaultCodeEnum.ApigwError:
                this.code = ErrorTypes.UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1601;
                break;
            case ErrorCode.BadRequest:
            case ApiError400DefaultCodeEnum.BadRequest:
                this.code = ErrorTypes.UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1602;
                this.type = ApiError400DefaultCodeEnum.BadRequest;
                break;
            case ApiError404DefaultCodeEnum.ResourceNotFound:
                this.code = ErrorTypes.UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1603;
                this.type = ApiError404DefaultCodeEnum.ResourceNotFound;
                break;
            case ApiError500DefaultCodeEnum.InternalServerError:
                this.code = ErrorTypes.UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1604;
                this.type = ApiError500DefaultCodeEnum.InternalServerError;
                break;
            default:
                this.code = ErrorTypes.UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_ERROR_C1699;
                this.type = 'UNIFIED_COLLECTION_SCREEN_DETAILS_ACTION_UNKNOWN_ERROR';
        }
    }
}
